import React from "react";
import CssClasses from "./AdminFooter.css";
import { connect } from "react-redux";

const AdminFooter = props => {
  return (
    <div className={CssClasses.container}>
      <div className={CssClasses.leftSection}>
        Terminal {props.machineInfo.TerminalLabel} - {props.machineInfo.Address}
      </div>
      <div className={CssClasses.rightSection}>
        Software version --> Browser: {props.machineInfo.BrowserVersion} WebApp:{" "}
        {props.machineInfo.WebAppVersion}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    machineInfo: state.rrAppState.machineInfo
  };
};

export default connect(mapStateToProps)(AdminFooter);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/AdminFooter/AdminFooter.js